import { actions as segmentioActions } from '@saucelabs/sl-util-segmentio';

const PREFIX = 'Performance -';

export const PERFORMANCE_EVENTS = Object.freeze({
  CHANGE_URL: `${PREFIX} Select URL`,
  HISTORY_OPEN: `${PREFIX} Show History`,
  OPEN_FILMSTRIP_METRICS: `${PREFIX} Show FilmStrip Metrics`,
  PERFORMANCE_REPORT_OPEN: `${PREFIX} Show Performance Report`,
});

export const trackEvent = (event) => segmentioActions.recordTrack(event);

export default trackEvent;
